import React, { useState } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import SortProblems from "./SortProblems.js";
import update from "immutability-helper";

const useStyles = makeStyles(theme => ({
    root: {
        margin: "auto"
    },
    cardHeader: {
        padding: theme.spacing(1, 2)
    },
    list: {
        width: 200,
        height: 230,
        backgroundColor: theme.palette.background.paper,
        overflow: "auto"
    },
    button: {
        margin: theme.spacing(0.5, 0)
    }
}));

const not = (a, b) => a.filter(value => b.indexOf(value) === -1);

const intersection = (a, b) => a.filter(value => b.indexOf(value) !== -1);

const ChosenClients = props => {
    const classes = useStyles();
    const [checked, setChecked] = useState([]);
    const [left, setLeft] = useState(props.lhs);
    const [right, setRight] = useState(props.rhs);
    const [problem, setProblem] = useState(null);

    const leftChecked = intersection(checked, left);
    const rightChecked = intersection(checked, right);

    const handleToggle = value => () => {
        const currentIndex = checked.indexOf(value);
        if (currentIndex === -1) setChecked(update(checked, { $push: [value] }));
        else setChecked(update(checked, { $splice: [[currentIndex, 1]] }));
    };

    const numberOfChecked = items => intersection(checked, items).length;

    const handleToggleAll = items => () => {
        if (numberOfChecked(items) === items.length) setChecked(not(checked, items));
        else setChecked(update(checked, { $push: items }));
    };

    const handleCheckedRight = () => {
        props.onChange(right.concat(leftChecked));
        setRight(right.concat(leftChecked));
        setLeft(not(left, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {
        props.onChange(not(right, rightChecked));
        setRight(not(right, rightChecked));
        setLeft(left.concat(rightChecked));
        setChecked(not(checked, rightChecked));
    };

    const handleSelectProblem = value => setProblem(value);

    const customList = (title, items) => (
        <Card>
            <CardHeader
                className={classes.cardHeader}
                avatar={
                    <Checkbox
                        onClick={handleToggleAll(items)}
                        checked={numberOfChecked(items) === items.length && items.length !== 0}
                        indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
                        disabled={items.length === 0}
                        inputProps={{ "aria-label": "all items selected" }}
                    />
                }
                title={title}
                subheader={`${numberOfChecked(items)}/${items.length} selected`}
            />
            {items === left ? (
                <>
                    <Divider />
                    <SortProblems problems={props.tags} onChange={handleSelectProblem} />
                </>
            ) : null}

            <Divider />
            <List className={classes.list} dense component="div" role="list">
                {items.map(value => {
                    const labelId = `transfer-list-all-item-${value}-label`;
                    if (items === left && problem && !(value.tags || []).includes(problem)) return <></>;
                    return (
                        <ListItem key={value.id} role="listitem" button onClick={handleToggle(value)}>
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked.indexOf(value) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ "aria-labelledby": labelId }}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={value.nameFirst} />
                        </ListItem>
                    );
                })}
                <ListItem />
            </List>
        </Card>
    );

    return (
        <Grid container spacing={2} justify="center" alignItems="center" className={classes.root}>
            <Grid item>{customList("Klienter", left)}</Grid>
            <Grid item>
                <Grid container direction="column" alignItems="center">
                    <Button
                        variant="outlined"
                        size="small"
                        className={classes.button}
                        onClick={handleCheckedRight}
                        disabled={leftChecked.length === 0}
                        aria-label="move selected right">
                        &gt;
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        className={classes.button}
                        onClick={handleCheckedLeft}
                        disabled={rightChecked.length === 0}
                        aria-label="move selected left">
                        &lt;
                    </Button>
                </Grid>
            </Grid>

            <Grid item>{customList("Valgte klienter", right)}</Grid>
        </Grid>
    );
};
export default connect(state => state, null, null, { forwardRef: true })(ChosenClients);
